<template>
    <div class="lottery-filter-container">
      <h1>旋转矩形工具</h1>
      
      <div class="lottery-selector">
        <el-select v-model="currentLottery" placeholder="请选择彩票类型" @change="clearAll">
          <el-option label="双色球红球" value="ssq"></el-option>
          <el-option label="大乐透前区" value="dlt"></el-option>
        </el-select>
      </div>
  
      <div class="selection-area">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ currentLottery === 'ssq' ? '红球' : '前区' }}选择</span>
            <el-tag type="info" style="margin-left: 10px;">
              请选择{{ currentLottery === 'ssq' ? '7-16' : '6-12' }}个号码
            </el-tag>
            <el-tag type="warning" style="margin-left: 10px;">
              已选 {{ selectedBalls.length }} 个
            </el-tag>
          </div>
          <div class="ball-area">
            <div 
              v-for="n in ballRange" 
              :key="`ball-${n}`" 
              class="ball"
              :class="{
                selected: selectedBalls.includes(n),
                red: currentLottery === 'ssq',
                front: currentLottery === 'dlt'
              }"
              @click="toggleBall(n)"
            >
              {{ n < 10 ? '0'+n : n }}
            </div>
          </div>
        </el-card>
      </div>
  
      <div class="control-area">
        <el-button type="primary" @click="toggleFilterPanel" plain>
          {{ showFilterPanel ? '隐藏缩水条件' : '显示缩水条件' }}
        </el-button>
        <el-button type="primary" @click="generateCombinations" :disabled="!canGenerate">生成组合</el-button>
        <el-button @click="clearAll">清空选择</el-button>
        <el-button type="success" @click="exportCombinations" :disabled="filteredCombinations.length === 0">导出结果</el-button>
        <el-tag v-if="showFilterPanel && filteredCombinations.length < allCombinations.length" type="warning">
          已过滤 {{ allCombinations.length - filteredCombinations.length }} 注
        </el-tag>
      </div>
  
      <!-- 缩水条件面板 -->
      <div class="filter-panel" v-show="showFilterPanel">
        <el-card class="filter-card">
          <div slot="header" class="clearfix">
            <span>缩水条件设置</span>
            <el-tag type="warning">过滤后不再保证"{{ currentLottery === 'ssq' ? '中6保5' : '中5保4' }}"</el-tag>
          </div>
          
          <!-- 双色球缩水条件 -->
          <div v-if="currentLottery === 'ssq'">
            <div class="filter-row">
              <span class="filter-label">AC值：</span>
              <el-checkbox-group v-model="filters.acValues">
                <el-checkbox v-for="n in 10" :key="`ac-${n}`" :label="n">{{n}}</el-checkbox>
              </el-checkbox-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">首位号码的奇偶值：</span>
              <el-radio-group v-model="filters.firstOddEven">
                <el-radio label="odd">奇数</el-radio>
                <el-radio label="even">偶数</el-radio>
                <el-radio label="">不限</el-radio>
              </el-radio-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">末位号码的奇偶值：</span>
              <el-radio-group v-model="filters.lastOddEven">
                <el-radio label="odd">奇数</el-radio>
                <el-radio label="even">偶数</el-radio>
                <el-radio label="">不限</el-radio>
              </el-radio-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">和值：</span>
              <!-- <el-input-number v-model="filters.sumMin" :min="minSum" :max="maxSum" size="small" :controls="false" placeholder="最小值"></el-input-number>
              <span> 至 </span>
              <el-input-number v-model="filters.sumMax" :min="minSum" :max="maxSum" size="small" :controls="false" placeholder="最大值"></el-input-number> -->
              <el-input 
                v-model="filters.sumMin" 
                placeholder="最小值" 
                style="width: 100px"
                @change="handleSumChange('sumMin')"
                type="number"
              ></el-input>
              <span> 至 </span>
              <el-input 
                v-model="filters.sumMax" 
                placeholder="最大值" 
                style="width: 100px"
                @change="handleSumChange('sumMax')"
                type="number"
              ></el-input>
              <el-radio-group v-model="filters.sumOddEven" style="margin-left: 20px;">
                <el-radio label="odd">奇数</el-radio>
                <el-radio label="even">偶数</el-radio>
                <el-radio label="">不限</el-radio>
              </el-radio-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">奇偶比：</span>
              <el-checkbox-group v-model="filters.oddEvenRatios">
                <el-checkbox v-for="ratio in ssqOddEvenRatios" :key="ratio" :label="ratio">{{ratio}}</el-checkbox>
              </el-checkbox-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">大小比：</span>
              <el-checkbox-group v-model="filters.bigSmallRatios">
                <el-checkbox v-for="ratio in ssqBigSmallRatios" :key="ratio" :label="ratio">{{ratio}}</el-checkbox>
              </el-checkbox-group>
              <span class="filter-note">(约定16以上为大)</span>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">质合比：</span>
              <el-checkbox-group v-model="filters.primeRatios">
                <el-checkbox v-for="ratio in ssqPrimeRatios" :key="ratio" :label="ratio">{{ratio}}</el-checkbox>
              </el-checkbox-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">连号组数：</span>
              <el-checkbox-group v-model="filters.consecutiveGroups">
                <el-checkbox label="0">无连号</el-checkbox>
                <el-checkbox label="1">1连号</el-checkbox>
                <el-checkbox label="2">2连号</el-checkbox>
                <el-checkbox label="3">3连号</el-checkbox>
                <el-checkbox label="4">4连号</el-checkbox>
                <el-checkbox label="5">5连号</el-checkbox>
              </el-checkbox-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">尾数不同号码：</span>
              <el-checkbox-group v-model="filters.differentEndings">
                <el-checkbox v-for="n in 5" :key="`end-${n+1}`" :label="n+1">{{n+1}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          
          <!-- 大乐透缩水条件 -->
          <div v-else>
            <div class="filter-row">
              <span class="filter-label">AC值：</span>
              <el-checkbox-group v-model="filters.acValues">
                <el-checkbox v-for="n in 7" :key="`ac-${n}`" :label="n">{{n}}</el-checkbox>
              </el-checkbox-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">首位号码的奇偶值：</span>
              <el-radio-group v-model="filters.firstOddEven">
                <el-radio label="odd">奇数</el-radio>
                <el-radio label="even">偶数</el-radio>
                <el-radio label="">不限</el-radio>
              </el-radio-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">末位号码的奇偶值：</span>
              <el-radio-group v-model="filters.lastOddEven">
                <el-radio label="odd">奇数</el-radio>
                <el-radio label="even">偶数</el-radio>
                <el-radio label="">不限</el-radio>
              </el-radio-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">和值：</span>
              <el-input-number v-model="filters.sumMin" :min="minSum" :max="maxSum" size="small"></el-input-number>
              <span> 至 </span>
              <el-input-number v-model="filters.sumMax" :min="minSum" :max="maxSum" size="small"></el-input-number>
              <el-radio-group v-model="filters.sumOddEven" style="margin-left: 20px;">
                <el-radio label="odd">奇数</el-radio>
                <el-radio label="even">偶数</el-radio>
                <el-radio label="">不限</el-radio>
              </el-radio-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">奇偶比：</span>
              <el-checkbox-group v-model="filters.oddEvenRatios">
                <el-checkbox v-for="ratio in dltOddEvenRatios" :key="ratio" :label="ratio">{{ratio}}</el-checkbox>
              </el-checkbox-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">大小比：</span>
              <el-checkbox-group v-model="filters.bigSmallRatios">
                <el-checkbox v-for="ratio in dltBigSmallRatios" :key="ratio" :label="ratio">{{ratio}}</el-checkbox>
              </el-checkbox-group>
              <span class="filter-note">(约定17以上为大)</span>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">质合比：</span>
              <el-checkbox-group v-model="filters.primeRatios">
                <el-checkbox v-for="ratio in dltPrimeRatios" :key="ratio" :label="ratio">{{ratio}}</el-checkbox>
              </el-checkbox-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">连号组数：</span>
              <el-checkbox-group v-model="filters.consecutiveGroups">
                <el-checkbox label="0">无连号</el-checkbox>
                <el-checkbox label="1">1连号</el-checkbox>
                <el-checkbox label="2">2连号</el-checkbox>
                <el-checkbox label="3">3连号</el-checkbox>
                <el-checkbox label="4">4连号</el-checkbox>
              </el-checkbox-group>
            </div>
            
            <div class="filter-row">
              <span class="filter-label">尾数不同号码：</span>
              <el-checkbox-group v-model="filters.differentEndings">
                <el-checkbox v-for="n in 4" :key="`end-${n+1}`" :label="n+1">{{n+1}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-card>
      </div>
  
      <div class="result-area" v-if="allCombinations.length > 0">
        <el-card class="result-card">
          <div slot="header" class="clearfix">
            <span>组合结果</span>
            <el-tag type="info">原始组合 {{ allCombinations.length }} 注</el-tag>
            <el-tag type="success" style="margin-left: 10px;">缩水后 {{ filteredCombinations.length }} 注</el-tag>
            <el-tag type="danger" style="margin-left: 10px;">共计 {{ totalCost }} 元</el-tag>
          </div>
          <div class="combination-list">
            <div 
              v-for="(combo, index) in filteredCombinations" 
              :key="`combo-${index}`" 
              class="combination-item"
            >
              <span class="combo-index">{{ index + 1 }}.</span>
              <span class="balls">
                <span 
                  v-for="(ball, ballIndex) in combo" 
                  :key="`ball-${index}-${ballIndex}`" 
                  class="ball small"
                  :class="{
                    red: currentLottery === 'ssq',
                    front: currentLottery === 'dlt'
                  }"
                >
                  {{ ball < 10 ? '0'+ball : ball }}
                </span>
              </span>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </template>
  
  <script>
  // 质数列表
  const PRIME_NUMBERS = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31]
  
  export default {
    name: 'LotteryFilterTool',
    data() {
      return {
        currentLottery: 'ssq',
        selectedBalls: [],
        allCombinations: [],
        showFilterPanel: false,
        // 双色球选项
        ssqOddEvenRatios: ['0:6', '1:5', '2:4', '3:3', '4:2', '5:1', '6:0'],
        ssqBigSmallRatios: ['0:6', '1:5', '2:4', '3:3', '4:2', '5:1', '6:0'],
        ssqPrimeRatios: ['0:6', '1:5', '2:4', '3:3', '4:2', '5:1', '6:0'],
        // 大乐透选项
        dltOddEvenRatios: ['0:5', '1:4', '2:3', '3:2', '4:1', '5:0'],
        dltBigSmallRatios: ['0:5', '1:4', '2:3', '3:2', '4:1', '5:0'],
        dltPrimeRatios: ['0:5', '1:4', '2:3', '3:2', '4:1', '5:0'],
        // 筛选条件
        filters: {
          acValues: [],
          firstOddEven: '',
          lastOddEven: '',
          sumMin: '',
          sumMax: '',
          sumOddEven: '',
          oddEvenRatios: [],
          bigSmallRatios: [],
          primeRatios: [],
          consecutiveGroups: [],
          differentEndings: []
        }
      }
    },
    computed: {
      ballRange() {
        return this.currentLottery === 'ssq' ? 33 : 35
      },
      minSelection() {
        return this.currentLottery === 'ssq' ? 7 : 6
      },
      maxSelection() {
        return this.currentLottery === 'ssq' ? 16 : 12
      },
      requiredBalls() {
        return this.currentLottery === 'ssq' ? 6 : 5
      },
      canGenerate() {
        return this.selectedBalls.length >= this.minSelection && 
               this.selectedBalls.length <= this.maxSelection
      },
      minSum() {
        const balls = [...this.selectedBalls].sort((a, b) => a - b)
        const smallest = balls.slice(0, this.requiredBalls)
        return smallest.reduce((sum, num) => sum + num, 0)
      },
      maxSum() {
        const balls = [...this.selectedBalls].sort((a, b) => b - a)
        const largest = balls.slice(0, this.requiredBalls)
        return largest.reduce((sum, num) => sum + num, 0)
      },
      filteredCombinations() {
        if (!this.showFilterPanel || !this.hasActiveFilters()) {
          return this.allCombinations
        }
        return this.allCombinations.filter(combo => {
          // AC值过滤
          if (this.filters.acValues.length > 0) {
            const acValue = this.calculateACValue(combo)
            if (!this.filters.acValues.includes(acValue)) return false
          }
          
          // 首位号码奇偶
          if (this.filters.firstOddEven) {
            const first = combo[0]
            const isOdd = first % 2 === 1
            if ((this.filters.firstOddEven === 'odd' && !isOdd) || 
                (this.filters.firstOddEven === 'even' && isOdd)) {
              return false
            }
          }
          
          // 末位号码奇偶
          if (this.filters.lastOddEven) {
            const last = combo[combo.length - 1]
            const isOdd = last % 2 === 1
            if ((this.filters.lastOddEven === 'odd' && !isOdd) || 
                (this.filters.lastOddEven === 'even' && isOdd)) {
              return false
            }
          }
          
          // 和值过滤
          const sum = combo.reduce((s, num) => s + num, 0)
          if (this.filters.sumMin !== '' && sum < Number(this.filters.sumMin)) return false
          if (this.filters.sumMax !== '' && sum > Number(this.filters.sumMax)) return false
          if (this.filters.sumOddEven) {
            const isSumOdd = sum % 2 === 1
            if ((this.filters.sumOddEven === 'odd' && !isSumOdd) || 
                (this.filters.sumOddEven === 'even' && isSumOdd)) {
              return false
            }
          }
          
          // 奇偶比
          if (this.filters.oddEvenRatios.length > 0) {
            const oddCount = combo.filter(num => num % 2 === 1).length
            const evenCount = this.requiredBalls - oddCount
            const ratio = `${oddCount}:${evenCount}`
            if (!this.filters.oddEvenRatios.includes(ratio)) return false
          }
          
          // 大小比
          if (this.filters.bigSmallRatios.length > 0) {
            const boundary = this.currentLottery === 'ssq' ? 16 : 17
            const bigCount = combo.filter(num => num > boundary).length
            const smallCount = this.requiredBalls - bigCount
            const ratio = `${bigCount}:${smallCount}`
            if (!this.filters.bigSmallRatios.includes(ratio)) return false
          }
          
          // 质合比
          if (this.filters.primeRatios.length > 0) {
            const primeCount = combo.filter(num => PRIME_NUMBERS.includes(num)).length
            const compositeCount = this.requiredBalls - primeCount
            const ratio = `${primeCount}:${compositeCount}`
            if (!this.filters.primeRatios.includes(ratio)) return false
          }
          
          // 连号组数
          if (this.filters.consecutiveGroups.length > 0) {
            const consecutiveCount = this.countConsecutiveGroups(combo)
            if (!this.filters.consecutiveGroups.includes(String(consecutiveCount))) return false
          }
          
          // 尾数不同号码
          if (this.filters.differentEndings.length > 0) {
            const endings = combo.map(num => num % 10)
            const uniqueEndings = new Set(endings).size
            if (!this.filters.differentEndings.includes(uniqueEndings)) return false
          }
          
          return true
        })
      },
      totalCost() {
        return this.filteredCombinations.length * 2
      }
    },
    methods: {
      handleSumChange(field) {
        // 输入为空时保持为空字符串
        if (this.filters[field] === '') return
        
        // 转换为数字（非数字输入会被转为NaN）
        const num = Number(this.filters[field])
        
        // 验证是否为有效数字
        if (isNaN(num) || !Number.isInteger(num)) {
          this.$message.warning('请输入整数')
          this.filters[field] = ''
          return
        }
        
        // 验证范围
        const minSum = this.minSum
        const maxSum = this.maxSum
        if (num < minSum || num > maxSum) {
          this.$message.warning(`请输入${minSum}-${maxSum}之间的值`)
          this.filters[field] = ''
        }
      },
      hasActiveFilters() {
        return (
          this.filters.acValues.length > 0 ||
          this.filters.firstOddEven !== '' ||
          this.filters.lastOddEven !== '' ||
          this.filters.sumMin !== null ||  // 注意这里是null检查
          this.filters.sumMax !== null ||  // 注意这里是null检查
          this.filters.sumOddEven !== '' ||
          this.filters.oddEvenRatios.length > 0 ||
          this.filters.bigSmallRatios.length > 0 ||
          this.filters.primeRatios.length > 0 ||
          this.filters.consecutiveGroups.length > 0 ||
          this.filters.differentEndings.length > 0
        )
      },
      toggleBall(n) {
        const index = this.selectedBalls.indexOf(n)
        if (index === -1) {
          if (this.selectedBalls.length < this.maxSelection) {
            this.selectedBalls.push(n)
            this.selectedBalls.sort((a, b) => a - b)
          } else {
            this.$message.warning(`最多只能选择${this.maxSelection}个号码`)
          }
        } else {
          this.selectedBalls.splice(index, 1)
        }
      },
      toggleFilterPanel() {
        this.showFilterPanel = !this.showFilterPanel;
        if (this.showFilterPanel && this.allCombinations.length > 0) {
          this.applyFilters()
        }
      },
      clearAll() {
        this.selectedBalls = []
        this.allCombinations = []
        this.filters = {
          acValues: [],
          firstOddEven: '',
          lastOddEven: '',
          sumMin: null,
          sumMax: null,
          sumOddEven: '',
          oddEvenRatios: [],
          bigSmallRatios: [],
          primeRatios: [],
          consecutiveGroups: [],
          differentEndings: []
        }
      },
      generateCombinations() {
        if (!this.canGenerate) return
        
        this.allCombinations = []
        this.generateAllCombinations(this.selectedBalls, this.requiredBalls, [], 0);
        if (this.showFilterPanel) {
          this.applyFilters()
        }
      },
      applyFilters() {
        this.$forceUpdate()
      },
      generateAllCombinations(arr, k, current, start) {
        if (current.length === k) {
          this.allCombinations.push([...current].sort((a, b) => a - b))
          return
        }
        
        for (let i = start; i < arr.length; i++) {
          current.push(arr[i])
          this.generateAllCombinations(arr, k, current, i + 1)
          current.pop()
        }
      },
      calculateACValue(combo) {
        // 计算AC值
        const diffs = []
        for (let i = 0; i < combo.length - 1; i++) {
          for (let j = i + 1; j < combo.length; j++) {
            diffs.push(Math.abs(combo[j] - combo[i]))
          }
        }
        
        const uniqueDiffs = new Set(diffs)
        return uniqueDiffs.size - (combo.length - 1)
      },
      countConsecutiveGroups(combo) {
        // 计算连号组数
        let count = 0
        let inConsecutive = false
        
        for (let i = 1; i < combo.length; i++) {
          if (combo[i] === combo[i - 1] + 1) {
            if (!inConsecutive) {
              count++
              inConsecutive = true
            }
          } else {
            inConsecutive = false
          }
        }
        
        return count
      },
      exportCombinations() {
        const lotteryName = this.currentLottery === 'ssq' ? '双色球红球' : '大乐透前区'
        let content = `${lotteryName}缩水结果\n\n`
        content += `选择号码: ${this.selectedBalls.map(n => n < 10 ? '0'+n : n).join(', ')}\n\n`
        
        // 添加缩水条件
        content += '缩水条件:\n'
        if (this.filters.acValues.length > 0) {
          content += `AC值: ${this.filters.acValues.join(', ')}\n`
        }
        if (this.filters.firstOddEven) {
          content += `首位号码: ${this.filters.firstOddEven === 'odd' ? '奇数' : '偶数'}\n`
        }
        if (this.filters.lastOddEven) {
          content += `末位号码: ${this.filters.lastOddEven === 'odd' ? '奇数' : '偶数'}\n`
        }
        if (this.filters.sumMin !== null || this.filters.sumMax !== null) {
          content += `和值范围: ${this.filters.sumMin || '无限制'} - ${this.filters.sumMax || '无限制'}\n`
        }
        if (this.filters.sumOddEven) {
          content += `和值: ${this.filters.sumOddEven === 'odd' ? '奇数' : '偶数'}\n`
        }
        if (this.filters.oddEvenRatios.length > 0) {
          content += `奇偶比: ${this.filters.oddEvenRatios.join(', ')}\n`
        }
        if (this.filters.bigSmallRatios.length > 0) {
          content += `大小比: ${this.filters.bigSmallRatios.join(', ')}\n`
        }
        if (this.filters.primeRatios.length > 0) {
          content += `质合比: ${this.filters.primeRatios.join(', ')}\n`
        }
        if (this.filters.consecutiveGroups.length > 0) {
          content += `连号组数: ${this.filters.consecutiveGroups.map(g => g === '0' ? '无连号' : `${g}连号`).join(', ')}\n`
        }
        if (this.filters.differentEndings.length > 0) {
          content += `尾数不同号码: ${this.filters.differentEndings.join(', ')}\n`
        }
        
        content += '\n组合结果:\n'
        this.filteredCombinations.forEach((combo, index) => {
          const ballStr = combo.map(n => n < 10 ? '0'+n : n).join(' ')
          content += `${index + 1}. ${ballStr}\n`
        })
        
        content += `\n共 ${this.filteredCombinations.length} 注，共计 ${this.totalCost} 元`
        
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${lotteryName}缩水结果.txt`
        link.click()
        URL.revokeObjectURL(url)
      }
    }
  }
  </script>
  
  <style scoped>
  .lottery-filter-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    font-family: "Microsoft YaHei", sans-serif;
  }
  
  h1 {
    text-align: center;
    color: #f44336;
    margin-bottom: 20px;
  }
  
  .lottery-selector {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .box-card, .filter-card {
    margin-bottom: 20px;
  }
  
  .ball-area {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .ball {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
    user-select: none;
    transition: all 0.3s;
    background-color: #f8f8f8;
    border: 1px solid #ddd;
  }
  
  .ball.red {
    color: #f44336;
    border-color: #f44336;
  }
  
  .ball.front {
    color: #f44336;
    border-color: #f44336;
  }
  
  .ball.selected {
    color: white;
  }
  
  .ball.selected.red {
    background-color: #f44336;
  }
  
  .ball.selected.front {
    background-color: #f44336;
  }
  
  .ball.small {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
  
  .control-area {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 30px 0;
  }
  
  .filter-panel {
    margin-top: 20px;
  }
  
  .filter-row {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    flex-wrap: wrap;
  }
  
  .filter-label {
    width: 120px;
    font-weight: bold;
    margin-right: 10px;
  }
  
  .filter-note {
    margin-left: 10px;
    color: #999;
    font-size: 12px;
  }
  
  .result-area {
    margin-top: 30px;
  }
  
  .combination-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 10px;
  }
  
  .combination-item {
    display: flex;
    align-items: center;
    padding: 5px;
    border-bottom: 1px dashed #eee;
  }
  
  .combo-index {
    margin-right: 10px;
    color: #666;
    width: 30px;
  }
  
  .balls {
    display: flex;
    gap: 5px;
  }
  
  .el-tag {
    margin-right: 5px;
  }
  
  .el-tag--danger {
    background-color: #fef0f0;
    border-color: #fde2e2;
    color: #f56c6c;
  }
  
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both;
  }
  
  .el-checkbox, .el-radio {
    margin-right: 15px;
  }
  </style>


// WEBPACK FOOTER //
// src/views/usingTools/rotatRectangle.vue